import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import {
  FaHome,
  FaUser,
  FaListAlt,
  FaEye,
  FaUserGraduate,
  FaInfoCircle,
  FaCalendarAlt,
  FaUserCircle,
  FaCrown,
  FaGifts,
  FaUsers,
  FaTruck,
  FaFileAlt,
  FaShoppingCart,
  FaDollarSign,
  FaCog,
  FaSignOutAlt,
  FaChevronDown,
} from "react-icons/fa";
import AddAdmin from "./Modals/Admin/AddAdmin";
import { FaUserTie } from "react-icons/fa6";

export default function Navbar({ isOpen, toggleSideBarStatus }) {
  // State for controlling sidebar and dropdown visibility
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const [isCardVisible, setIsCardVisible] = useState(false);

  const handleProfileClick = () => {
    setIsCardVisible(!isCardVisible);
  };

  const [dropdowns, setDropdowns] = useState({
    master: false,
    payment: false,
    purchase: false,
    others: false,
  });
  // const [activeMenu, setActiveMenu] = useState('dashboard');

  const [profileData, setProfileData] = useState({
    profileUrl: "",
    firstName: "",
    lastName: "",
  });

  const [userRole, setuserRole] = useState("");

  // Fetch profile data using member_id
  useEffect(() => {
    const profession_id = sessionStorage.getItem("profession_id");
    // alert(profession_id)
    if (profession_id) {
      setuserRole(profession_id);
    }
  }, []);

  const [activeMenu, setActiveMenu] = useState("");
  const [loginname, setloginname] = useState("");

  useEffect(() => {
    if (userRole === "1") {
      setActiveMenu("AdminApprovedZoneTrainer");
      setloginname("Super Admin");
      setActiveMenu(location.pathname.slice(1));
    } else if (userRole === "2") {
      setActiveMenu("AdminApprovedZoneTrainer");
      setloginname("Admin");
      setActiveMenu(location.pathname.slice(1));
    } else if (userRole === "3") {
      setActiveMenu("lompresidentEventStatus");
      setloginname("Lom President");
      setActiveMenu(location.pathname.slice(1));
    } else if (userRole === "4") {
      setActiveMenu("trainersEventStatus");
      setloginname("Zone Trainer");
      setActiveMenu(location.pathname.slice(1));
    }
  }, [userRole]);

  // // setuserRole(sessionStorage.getItem('AdminName'))

  const toggleSidebar = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    sessionStorage.setItem("sidebarOpen", JSON.stringify(newState)); // Store the boolean value
  };

  // Close sidebar when clicking on overlay
  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  // Fetch profile data using member_id
  useEffect(() => {
    const memberId = sessionStorage.getItem("memberId");
    if (memberId) {
      fetchProfileData(memberId);
    }
  }, []);

  const fetchProfileData = async (memberId) => {
    try {
      const response = await axios.get("/members/read", {
        params: {
          member_id: memberId, // Pass member_id as a query parameter
        },
      });

      if (response.status === 200) {
        const data = response.data;
        setProfileData({
          profileUrl: data.profile_url || "",
          firstName: data.first_name || "",
          lastName: data.last_name || "",
        });
      } else {
        console.error("Failed to fetch profile data:", response.data.error);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };

  const url = sessionStorage.getItem("url");

  // Toggle dropdown
  const toggleDropdown = (dropdown) => {
    setDropdowns((prevState) => ({
      ...prevState,
      [dropdown]: !prevState[dropdown], // Toggle the specific dropdown
    }));
  };

  // Handle menu click (set active menu and toggle dropdown)
  const handleMenuClick = (menu, dropdown) => {
    setActiveMenu(menu); // Set active menu
    toggleDropdown(dropdown); // Toggle dropdown visibility
  };

  const imageUrl = profileData.profileUrl
    ? `${url}/members_images/${profileData.profileUrl}`
    : "/default-profile.png";

  return (
    <div>
      {/* Sidebar Overlay */}
      {/* Navbar */}
      {/* border-b border-white */}
      <nav className="fixed top-0 z-50 w-full bg-nav-bg-primary1  dark:bg-nav-bg-secondary1">
        <div className="px-3 py-1 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start rtl:justify-end">
              <button
                aria-controls="logo-sidebar"
                type="button"
                className="inline-flex items-center p-2 text-sm text-white rounded-lg  hover:bg-black focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-[#ffffff] dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                onClick={toggleSideBarStatus}
              >
                <span className="sr-only">Open sidebar</span>
                <svg
                  className="w-6 h-6"
                  aria-hidden="true"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    clipRule="evenodd"
                    fillRule="evenodd"
                    d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                  ></path>
                </svg>
              </button>
              {/* <img src="/jci_logo.png" alt="Logo" className="w-12 ml-2 mx-auto mb-2 mt-2" /> */}
              <span className="self-center text-sm font-semibold sm:text-base ml-5 whitespace-nowrap dark:text-gray text-nav-text-primary1">
                GURU FINDER
              </span>
            </div>
            {/* <div className="flex items-center">
              <div className="flex items-center ms-3">
                <button
                  type="button"
                  className="flex text-sm bg-[#ffffff] rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                  aria-expanded="false"
                  data-dropdown-toggle="dropdown-user"
                >
                  <span className="sr-only">Open user menu</span>
                  <div className="flex items-center space-x-2">
                  
                   <img
                      src={profileData.profileUrl ? `${url}/members/members_images/${profileData.profileUrl}` : '/default_avatar.png'}
                      alt="Profile"
                      className="w-7 h-7 rounded-full outline outline-2 outline-white"
                    /> 
                </div>
                </button>
              </div> */}
            <div className="flex items-center ms-3">
              <button
                type="button"
                onClick={handleProfileClick}
                className="flex text-sm bg-[#ffffff] rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                aria-expanded={isCardVisible}
              >
                <span className="sr-only">Open user menu</span>
                <div className="flex items-center space-x-2">
                  <img
                    src={
                      profileData.profileUrl
                        ? `${url}/members/members_images/${profileData.profileUrl}`
                        : `${process.env.PUBLIC_URL}/default_avatar.png`
                    }
                    alt="Profile"
                    className="w-7 h-7 rounded-full outline outline-2 outline-white"
                  />
                </div>
              </button>

              <span className="text-sm sm:text-base ml-3 text-nav-text-primary1">
                {/* {profileData.firstName || "Guest"} {profileData.lastName || ""} */}
                {/* {loginname} */}
                {loginname === "Lom President" ? "LO" : loginname}
                {/* {profileData.profileUrl} */}
              </span>

              {/* Dropdown Card */}
              {isCardVisible && (
                <div className="absolute top-12 right-0 z-10 w-64 bg-white border border-gray-200 rounded-lg shadow-lg">
                  {/* <div className="p-4">
                            <img
                              src={
                                profileData.profileUrl
                                  ? `${url}/members/members_images/${profileData.profileUrl}`
                                  : "/default_avatar.png"
                              }
                              alt="Profile"
                              className="w-16 h-16 mx-auto rounded-full"
                            />
                            <h3 className="mt-2 text-center text-lg font-semibold">
                              {profileData.firstName || "Guest"} {profileData.lastName || ""}
                            </h3>
                            <p className="text-center text-gray-600">{loginname}</p>
                          </div> */}
                  {/* <div className="border-t border-gray-200">
                    <ul className="py-2">
                      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                        Zone Trainers
                      </li>
                      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                        Lom President
                      </li>
                      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                        Admin
                      </li>
                      <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                        Super Admin
                      </li>
                    </ul>
                  </div> */}
                </div>
              )}
              {/* <img
                      src={imageUrl}
                      alt="Profile"
                      className="w-8 h-8 rounded-full"
                    /> */}
              {/* Colored SVG Icon */}
              {/* <span className='ml-2 text-nav-text-primary1 font-sans font-bold'>{sessionStorage.getItem("username")}</span> */}
            </div>
          </div>
        </div>
      </nav>

      {/* Sidebar */}
      {isOpen && (
        <aside
          id="logo-sidebar"
          className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform bg-nav-bg-primary border-r shadow-lg shadow-blue-700 sm:translate-x-0 dark:bg-nav-bg-secondary ${
            sidebarOpen ? "open" : ""
          }`}
          aria-label="Sidebar"
        >
          <div className="h-full px-3 pb-4 overflow-y-auto bg-nav-bg-primary dark:bg-nav-bg-secondary">
            <ul className="space-y-2 font-medium">
              {/* Sidebar items here */}
              <li>
                {userRole === "4" && (
                  <Link
                    to="/trainersEventStatus"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "trainersEventStatus"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary`}
                    onClick={() => {
                      setActiveMenu("trainersEventStatus");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaHome
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "trainersEventStatus"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3  ${
                        activeMenu === "trainersEventStatus"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Dashboard
                    </span>
                  </Link>
                )}
                {userRole === "3" && (
                  <Link
                    to="/lompresidentEventStatus"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "lompresidentEventStatus"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary`}
                    onClick={() => {
                      setActiveMenu("lompresidentEventStatus");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaHome
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "lompresidentEventStatus"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3  ${
                        activeMenu === "lompresidentEventStatus"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Dashboard
                    </span>
                  </Link>
                )}

                {userRole == "1" && (
                  <Link
                    to="/AdminApprovedZoneTrainer"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "AdminApprovedZoneTrainer"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary`}
                    onClick={() => {
                      setActiveMenu("AdminApprovedZoneTrainer");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaHome
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "AdminApprovedZoneTrainer"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3  ${
                        activeMenu === "AdminApprovedZoneTrainer"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Dashboard
                    </span>
                  </Link>
                )}
                {userRole == "2" && (
                  <Link
                    to="/AdminApprovedZoneTrainer"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "AdminApprovedZoneTrainer"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary`}
                    onClick={() => {
                      setActiveMenu("AdminApprovedZoneTrainer");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaHome
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "AdminApprovedZoneTrainer"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3  ${
                        activeMenu === "AdminApprovedZoneTrainer"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Dashboard
                    </span>
                  </Link>
                )}
              </li>
              {/* Other sidebar links */}
              {/* { userRole != '3' && (
            <li>
              <Link to="/myProfile" className={`flex items-center p-2 rounded-lg group ${activeMenu === 'profile' ? 'bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary' : ''} hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `} onClick={() => { setActiveMenu('profile'); }}  style={{ textDecoration: 'none' }} >
                <FaUserCircle className={`flex-shrink-0 w-5 h-5  transition duration-75 ${activeMenu === 'profile' ? 'text-nav-text-hover-primary dark:text-nav-text-hover-secondary' : 'text-nav-text-primary-icon dark:text-nav-text-secondary-icon'} group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`} />
                <span className={`ms-3  ${activeMenu === 'profile' ? 'text-nav-text-hover-primary dark:text-nav-text-hover-secondary' : 'text-nav-text-primary dark:text-nav-text-secondary'} group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}>My Profile</span>
              </Link>
            </li>
            )} */}
              {/* <li>
               <Link to="/events" className={`flex items-center p-2 rounded-lg group ${activeMenu === 'events' ? 'bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary' : ''} hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `} onClick={() => { setActiveMenu('events'); }} style={{ textDecoration: 'none' }}  >
                 <FaCalendarAlt className={`flex-shrink-0 w-5 h-5 transition duration-75 ${activeMenu === 'events' ? 'text-nav-text-hover-primary dark:text-nav-text-hover-secondary' : 'text-nav-text-primary-icon dark:text-nav-text-secondary-icon'} group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`} />
                <span className={`ms-3 ${activeMenu === 'events' ? 'text-nav-text-hover-primary dark:text-nav-text-hover-secondary' : 'text-nav-text-primary dark:text-nav-text-secondary'} group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}>Events</span>
              </Link>
            </li> */}
              {userRole == "4" && (
                <li>
                  <Link
                    to="/zoneTrainers1"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "zonetrainers1"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("zonetrainers1");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaUserTie
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "zonetrainers1"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "zonetrainers1"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Add myProfile
                    </span>
                  </Link>
                </li>
              )}
              {userRole == "4" && (
                <li>
                  <Link
                    to="/trainersContest"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "trainersContest"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("trainersContest");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaUserTie
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "trainersContest"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "trainersContest"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Contest
                    </span>
                  </Link>
                </li>
              )}
              {(userRole == "2" || userRole == "1") && (
                <li>
                  <Link
                    to="/lompresidentEventStatus"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "lompresidentEventStatus"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("lompresidentEventStatus");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaInfoCircle
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "lompresidentEventStatus"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "lompresidentEventStatus"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Event Status
                    </span>
                  </Link>
                </li>
              )}
              {userRole == "1" && (
                <li>
                  <Link
                    to="/adminpage"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "adminpage"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("adminpage");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaUserTie
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "adminpage"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "adminpage"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Admin
                    </span>
                  </Link>
                </li>
              )}
              {(userRole == "2" || userRole == "1") && (
                <li>
                  <Link
                    to="/lomPresident"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "lomPresident"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("lomPresident");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaCrown
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "lomPresident"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "lomPresident"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      LO
                    </span>
                  </Link>
                </li>
              )}
              {(userRole == "2" || userRole == "1") && (
                <li>
                  <Link
                    to="/zoneTrainers"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "zonetrainers"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("zonetrainers");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaUsers
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "zonetrainers"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "zonetrainers"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Zone Trainers
                    </span>
                  </Link>
                </li>
              )}
              {(userRole == "2" || userRole == "1") && (
                <li>
                  <Link
                    to="/contest"
                    className={`flex items-center p-2 rounded-lg group ${
                      activeMenu === "contest"
                        ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                        : ""
                    } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                    onClick={() => {
                      setActiveMenu("contest");
                    }}
                    style={{ textDecoration: "none" }}
                  >
                    <FaUsers
                      className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                        activeMenu === "contest"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    />
                    <span
                      className={`ms-3 ${
                        activeMenu === "contest"
                          ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                          : "text-nav-text-primary dark:text-nav-text-secondary"
                      } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                    >
                      Contest
                    </span>
                  </Link>
                </li>
              )}
              {userRole != "4" && (
                <></>
                // <li>
                //   <Link
                //     to="/event"
                //     className={`flex items-center p-2 rounded-lg group ${
                //       activeMenu === "event"
                //         ? "bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary"
                //         : ""
                //     } hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `}
                //     onClick={() => {
                //       setActiveMenu("event");
                //     }}
                //     style={{ textDecoration: "none" }}
                //   >
                //     <FaCalendarAlt
                //       className={`flex-shrink-0 w-5 h-5 transition duration-75 ${
                //         activeMenu === "event"
                //           ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                //           : "text-nav-text-primary-icon dark:text-nav-text-secondary-icon"
                //       } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                //     />
                //     <span
                //       className={`ms-3 ${
                //         activeMenu === "event"
                //           ? "text-nav-text-hover-primary dark:text-nav-text-hover-secondary"
                //           : "text-nav-text-primary dark:text-nav-text-secondary"
                //       } group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}
                //     >
                //       Events
                //     </span>
                //   </Link>
                // </li>
              )}

              {userRole != "4" && (
                <></>
                // <li>
                //    <Link to="/viewallEvents" className={`flex items-center p-2 rounded-lg group ${activeMenu === 'viewallEvents' ? 'bg-nav-bg-hover-primary dark:bg-nav-bg-hover-secondary' : ''} hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary `} onClick={() => { setActiveMenu('viewallEvents'); }} style={{ textDecoration: 'none' }}  >
                //      <FaEye className={`flex-shrink-0 w-5 h-5 transition duration-75 ${activeMenu === 'viewallEvents' ? 'text-nav-text-hover-primary dark:text-nav-text-hover-secondary' : 'text-nav-text-primary-icon dark:text-nav-text-secondary-icon'} group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`} />
                //     <span className={`ms-3 ${activeMenu === 'viewallEvents' ? 'text-nav-text-hover-primary dark:text-nav-text-hover-secondary' : 'text-nav-text-primary dark:text-nav-text-secondary'} group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary`}>View All Events</span>
                //   </Link>
                // </li>
              )}

              <li>
                <Link
                  to="/"
                  className="flex items-center p-2 text-nav-text-primary rounded-lg dark:text-nav-text-secondary group-hover:text-nav-text-hover-primary hover:bg-nav-bg-hover-primary dark:hover:bg-nav-bg-hover-secondary group"
                  onClick={() => {
                    sessionStorage.clear();
                    sessionStorage.clear();
                    closeSidebar();
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <FaSignOutAlt className="flex-shrink-0 w-5 h-5 text-nav-text-primary-icon transition duration-75 dark:text-nav-text-secondary-icon group-hover:text-nav-text-hover-primary dark:group-hover:text-nav-text-hover-secondary" />
                  <span className="ms-3 text-nav-text-primary group-hover:text-nav-text-hover-primary">
                    Logout
                  </span>
                </Link>
              </li>
            </ul>
          </div>
        </aside>
      )}
    </div>
  );
}
